import React, { useState, useEffect, Fragment } from "react";

// Semantic UI React
import { Checkbox, List, Header, Input, Icon } from "semantic-ui-react";

// Other
import TileLayer from "@arcgis/core/layers/TileLayer";
import localforage from "localforage";
import { isEmpty } from "../../Shared/Functions";

export default function LayerWidget({
  view,
  setVisibleLayers,
  localConfig,
  setLocalConfig,
}) {
  const [config, setConfig] = useState(null);
  const [sublayers, setSublayers] = useState(null);
  const [filterText, setFilterText] = React.useState("");

  useEffect(() => {
    let match = view.map.findLayerById("identify_layers");

    // set teh default visible sublayers passed from the localconfig
    const visible = localConfig.identify_layers;

    setSublayers(
      match.sublayers.items.map((layer) => {
        // Check if layer is in the configs
        var config = match.config.find(
          (record) => record.service_index == layer.id
        );

        if (config) {
          // Override and add additional properties
          layer.title = config.name;
          // layer.visible = config.visible;
          layer._agency = config.agency;
          // layer.config = config;
          config.layer = layer;

          // console.warn(layer.title, config, visible.includes(config.service_index))

          // check the visibility
          layer.visible = visible.includes(config.service_index);
          config.visible = layer.visible;

          if (!isEmpty(config.tiled_url)) {
            // Hide the current layer from the legend since it has a tiled layer
            layer.legendEnabled = false;

            // Create the tile layer and store it within the identify layer as a property
            layer._tile_reference = new TileLayer({
              url: config.tiled_url,
              visible: layer.visible,
              index: 1,
              minScale: layer.minScale,
              maxScale: layer.maxScale,
              title: config.name,
              print: true,
            });

            // If the layer is visible then add the layer to the map
            if (layer.visible) {
              view.map.layers.add(layer._tile_reference);
            }
          }

          return layer;
        }
      })
    );

    setVisibleLayers(visible);
    setConfig(match.config);
  }, []);

  const handleClick = (config) => {
    // console.warn({ config });

    const visible = config.layer.visible ? true : false;

    // create a new isntance of the localconfig object
    var obj = { ...localConfig };

    if (visible) {
      const index = obj.identify_layers.indexOf(config.service_index);
      if (index > -1) {
        obj.identify_layers.splice(index, 1);
      }
    } else {
      // Add the layer id to the array if it doesn't exist
      obj.identify_layers.indexOf(config.service_index) === -1 &&
        obj.identify_layers.push(config.service_index);
      // Sort the array
      obj.identify_layers = obj.identify_layers.sort();
    }

    setLocalConfig(obj);

    // flip the visibility
    config.layer.visible = !visible;

    // check if there is a tile reference
    if (config.layer._tile_reference) {
      // If so then set the visibility
      config.layer._tile_reference.visible = !visible;
      // Check if it has been added the map and if not do so (lazy load)
      if (!config.layer._tile_reference.loaded) {
        view.map.layers.add(config.layer._tile_reference);
      }
    }
  };

  if (!config || !sublayers) {
    return null;
  }

  return (
    <div id="layer_widget">
      <Input
        fluid
        style={{ marginBottom: ".5em" }}
        icon={
          filterText.length > 0 ? (
            <Icon name="remove" link onClick={() => setFilterText("")} />
          ) : null
        }
        // iconPosition="right"
        placeholder="Filter Layers"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      />

      <Header as="h5" block className="no-margin" style={{ fontSize: "10pt" }}>
        Des Moines County
      </Header>
      <List style={{ padding: "0 .5em" }}>
        {config
          .filter((layer) => layer.agency === "Des Moines County")
          .filter(
            (layer) =>
              layer.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1
          )
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((layer) => {
            return (
              <List.Item key={layer.id} style={{ paddingBottom: ".5em" }}>
                <Checkbox
                  style={{ width: "100%" }}
                  defaultChecked={layer.visible}
                  label={layer.name}
                  onClick={(e) => handleClick(layer)}
                />
              </List.Item>
            );
          })}
      </List>
      <Header as="h5" block className="no-margin" style={{ fontSize: "10pt" }}>
        Burlington
      </Header>
      <List style={{ padding: "0 .5em" }}>
        {config
          .filter((layer) => layer.agency === "Burlington")
          .filter(
            (layer) =>
              layer.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1
          )
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((layer) => {
            return (
              <List.Item key={layer.id} style={{ paddingBottom: ".5em" }}>
                <Checkbox
                  style={{ width: "100%" }}
                  defaultChecked={layer.visible}
                  label={layer.name}
                  onClick={(e) => handleClick(layer)}
                />
              </List.Item>
            );
          })}
      </List>
      <Header as="h5" block className="no-margin" style={{ fontSize: "10pt" }}>
        West Burlington
      </Header>
      <List style={{ padding: "0 .5em" }}>
        {config
          .filter((layer) => layer.agency === "West Burlington")
          .filter(
            (layer) =>
              layer.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1
          )
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .map((layer) => {
            return (
              <List.Item key={layer.id} style={{ paddingBottom: ".5em" }}>
                <Checkbox
                  style={{ width: "100%" }}
                  defaultChecked={layer.visible}
                  label={layer.name}
                  onClick={(e) => handleClick(layer)}
                />
              </List.Item>
            );
          })}
      </List>
    </div>
  );
}
